import React from 'react'
import RecordingDetectionsSVG, { TOP_PAD, PX_PER_SEC } from '../lib/recordingDetectionsSVG'

export default function RecordingSVG({ record, currentTime = 0, onSeek }) {
	const handleClick = (e) => {
		// Check for data-seek-time on the clicked element or its parent
		let target = e.target;
		let seekTime = target.dataset?.seekTime || target.getAttribute?.('data-seek-time');
		let detectionInfo = target.dataset?.detectionInfo || target.getAttribute?.('data-detection-info');
		
		// Also check parent elements (in case click is on text content)
		if (!seekTime && target.parentElement) {
			seekTime = target.parentElement.dataset?.seekTime || target.parentElement.getAttribute?.('data-seek-time');
			detectionInfo = target.parentElement.dataset?.detectionInfo || target.parentElement.getAttribute?.('data-detection-info');
		}
		
		if (seekTime && onSeek) {
			e.preventDefault();
			e.stopPropagation();
			
			// Log detection info if available
			if (detectionInfo) {
				try {
					console.log(JSON.parse(detectionInfo));
				} catch (err) {
					// ignore parse errors
				}
			}
			
			onSeek(parseFloat(seekTime));
		}
	};

	// Calculate playhead Y position based on SVG constants
	const playheadY = TOP_PAD + (currentTime * PX_PER_SEC);

	return (
		<div style={{ position: 'relative' }} onClick={handleClick}>
			{/* Playhead line - behind the SVG content */}
			<div style={{
				position: 'absolute',
				top: playheadY,
				left: 0,
				right: 0,
				height: 2,
				background: '#ff0000',
				pointerEvents: 'none',
				zIndex: 0
			}} />
			<div
				style={{ position: 'relative', zIndex: 1 }}
				dangerouslySetInnerHTML={{
					__html: new RecordingDetectionsSVG(record).build()
				}}
			/>
		</div>
	);
}
